"use client";

import { useAtomValue } from "jotai";
import { useReducedMotion } from "motion/react";
import * as m from "motion/react-m";

import { useIsMobile } from "@/hooks/use-mobile";
import { isSearchFocusedAtom } from "@/lib/atoms/search-atoms";

export function AppHeaderSlideOver({ children }: { children: React.ReactNode }) {
  const isSearchFocused = useAtomValue(isSearchFocusedAtom);
  const isMobile = useIsMobile();
  const shouldReduceMotion = useReducedMotion();

  return (
    <m.div
      className="flex h-full items-center gap-1.5 justify-self-end"
      animate={{
        // Only animate on mobile; on desktop keep fully visible
        opacity: isMobile ? (isSearchFocused ? 0 : 1) : 1,
        x: isMobile && !shouldReduceMotion ? (isSearchFocused ? 16 : 0) : 0,
      }}
      transition={
        shouldReduceMotion
          ? { duration: 0.1 }
          : {
              type: "spring",
              stiffness: 600,
              damping: 35,
            }
      }
      initial={false}
      style={{ pointerEvents: isSearchFocused && isMobile ? "none" : "auto" }}
    >
      {children}
    </m.div>
  );
}
